import styles from "./svgs.module.scss";

function DeliveryRapidShippingIcon(props: any) {
  const { width = 35, height = 35 } = props;
  return (
    <i className={`${styles.icon} ${styles.delivery_icons}`} style={{ width, height, backgroundPosition: `0 -${width * 2}px` }} />
  );
}

export default DeliveryRapidShippingIcon;
